<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <div class="card card-custom">
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">{{$t('menu.offer_customer_tests')}}</span>
            <span class="text-muted mt-1 font-weight-bold font-size-sm">{{$t('menu.definitions')}}</span>
          </h3>
          <div class="card-toolbar">
            <b-button class="btn btn-primary font-weight-bold py-3 px-6" v-b-modal.add_group>
              <i class="ki ki-plus icon-1x mr-2"></i>{{ $t('tests.add_group') }}
            </b-button>

            <b-modal id="add_group" :cancel-title="$t('general.cancel')" :ok-title="$t('general.save')" :title="$t('tests.add_group')">
              <b-form-group id="input-group-2" :label="$t('tests.group_name')" label-for="input-2">
                <b-form-input
                    id="input-2"
                    required
                    :placeholder="$t('tests.group_name')"
                ></b-form-input>
              </b-form-group>
            </b-modal>
          </div>
        </div>
        <div class="card-body pt-10">
          <div class="row">
            <div class="col-xl-12">
              <div class="separator separator-dashed mb-5"></div>
              <data-table
                  :items="items"
                  :fields="report.fields"
                  :paginate="report.paginate"
                  page.sync="3"
                  perPage.sync="10"
              >
              </data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "InternalTests",
  components: { DataTable, DashboardBox },
  methods: {
    ClearForm(){
      this.form = {
        firstname: '',
        lastname : '',
        email : '',
        phone : ''
      };
    },

  },
  data() {
    return {
      form : {
        firstname : 'Çağdaş',
        lastname : 'Mert',
        email : 'cagdas.mert@dorinsight.com',
        phone : '5309617970'
      },
      items : [
        {'group_name' : 'Ayşegül Yürüdüm', 'member_count' : '10' },
        {'group_name' : 'Bahar', 'member_count' : '170' },
        {'group_name' : 'Barış Tuncaboylu', 'member_count' : '123' },
        {'group_name' : 'Çağdaş Mert', 'member_count' : '278' },
        {'group_name' : 'Emine', 'member_count' : '43' },
        {'group_name' : 'Mujgan', 'member_count' : '55' },
        {'group_name' : 'Napolyon', 'member_count' : '78' },
        {'group_name' : 'Nermin', 'member_count' : '142' },
      ],
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'group_name', label: 'Grup Adı', sortable: false},
          {key: 'member_count', label: 'Kişi Sayısı', sortable: true},
          {key: 'customer_group_actions', label: 'İşlem', sortable: false},
        ],

      },
      selected : null,
      groups : [
        { text: this.$t('offers.offer_carts'), value: null },
        'Bilyoner 2020',
        'Adidas',
        'Airbnb',
        'GAP',
        'B&Q',
      ]
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('menu.definitions'), route: "alert" },
      { title: this.$t('menu.offer_customer_tests') }
    ]);
  },

}
</script>

<style scoped>

</style>
